<template>
    <span>
        <h6 class="heading6 mb-0" v-if="getPromotionCost(product)">
            <span class="text_primary_red mr_18">
                As low as ${{ discountedPrice(product) }}
            </span>
            <span class="text_light_grey">
                ${{ getRetailPrice(product) }}
            </span>
        </h6>
        <h6 class="heading6 mb-0" v-else>
            <span class="text_primary_red mr_18">
                As low as ${{ getRetailPrice(product) }}
            </span>
        </h6>
    </span>
</template>

<script>
import ApiService from "@/common/api.service";

let sharedMarkupTiers = null;
let sharedMarkupTiersPromise = null;

export default {
    /* eslint-disable */
    name: "Productoffer",
    /* eslint-enable */
    props: {
        product: {
            required: true
        },
        tShirt24Hour: {
            required: false,
            default: () => false
        }
    },
    data() {
        return {
            markupTiers: []
        };
    },
    created() {
        this.ensureMarkupTiersLoaded();
    },
    methods: {
        getTemplateCandidateFromObject(obj) {
            if (!obj || typeof obj !== "object") return null;
            const candidates = [
                obj.selected_pricing_template_id,
                obj.decoration_price_template,
                obj.decoration_price_template_id,
                obj.price_template_id,
                obj.template_id,
                obj.templateId,
                obj.decoration_template_id,
                obj.imprint_template_id
            ];
            for (let i = 0; i < candidates.length; i++) {
                const value = candidates[i];
                if (value !== undefined && value !== null && value !== "") {
                    return value;
                }
            }
            return null;
        },
        resolveTemplateId(product, service) {
            const rawTemplateId =
                this.getTemplateCandidateFromObject(service) ||
                this.getTemplateCandidateFromObject(
                    service && service.master_service
                ) ||
                this.getTemplateCandidateFromObject(
                    service && service.default_service
                ) ||
                this.getTemplateCandidateFromObject(product);

            if (rawTemplateId === null || rawTemplateId === undefined) {
                return null;
            }
            const normalizedTemplateId = parseInt(rawTemplateId, 10);
            return isNaN(normalizedTemplateId) ? null : normalizedTemplateId;
        },
        async ensureMarkupTiersLoaded() {
            if (Array.isArray(sharedMarkupTiers) && sharedMarkupTiers.length > 0) {
                this.markupTiers = sharedMarkupTiers;
                return;
            }

            if (!sharedMarkupTiersPromise) {
                sharedMarkupTiersPromise = ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        sharedMarkupTiers = Array.isArray(data.markup_tiers)
                            ? data.markup_tiers
                            : [];
                        return sharedMarkupTiers;
                    })
                    .catch(() => {
                        sharedMarkupTiers = [];
                        return [];
                    });
            }

            this.markupTiers = await sharedMarkupTiersPromise;
        },
        getMarkupFromTier(price, decorationType, templateId) {
            if (
                !Array.isArray(this.markupTiers) ||
                !this.markupTiers.length ||
                price === undefined ||
                price === null ||
                decorationType === undefined ||
                decorationType === null ||
                templateId === undefined ||
                templateId === null
            ) {
                return null;
            }

            const normalizedPrice = parseFloat(price);
            const tier = this.markupTiers.find(
                (row) =>
                    decorationType == row.decoration_id &&
                    templateId == row.template_id &&
                    parseFloat(row.start_price) <= normalizedPrice &&
                    parseFloat(row.end_price) >= normalizedPrice
            );

            return tier ? parseFloat(tier.markup) : null;
        },
        getResolvedMarkupPercentage(product, service, basePrice) {
            const decorationType =
                service &&
                service.decoration_type !== undefined &&
                service.decoration_type !== null
                    ? service.decoration_type
                    : product.decoration_type;
            const templateId = this.resolveTemplateId(product, service);

            const tierMarkup = this.getMarkupFromTier(
                basePrice,
                decorationType,
                templateId
            );
            if (tierMarkup !== null) {
                return tierMarkup;
            }

            if (
                service &&
                service.markup_percentage !== undefined &&
                service.markup_percentage !== null
            ) {
                return parseFloat(service.markup_percentage) || 0;
            }
            return parseFloat(product.price_markup_percentage || 0);
        },
        parseJSON(value) {
            if (typeof value !== "string") return value;
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        },
        getDefaultDecorationService(product) {
            const decorations = this.parseJSON(product && product.decorations);
            const list =
                Array.isArray(decorations) &&
                decorations[0] &&
                Array.isArray(decorations[0].decoration_type_list)
                    ? decorations[0].decoration_type_list
                    : [];
            if (!list.length) return null;
            return (
                list.find(
                    (service) =>
                        service &&
                        (service.is_default === 1 ||
                            service.is_default === true ||
                            service.is_default === "1")
                ) || list[0]
            );
        },
        parseMatrix(product, service = null) {
            const source =
                service && service.price_decoration_bulk != null
                    ? service.price_decoration_bulk
                    : product.price_decoration_bulk;
            const bulk = this.parseJSON(source);
            return bulk && typeof bulk === "object" ? bulk : null;
        },
        getDefaultSubProduct(product) {
            if (
                !Array.isArray(product.MainNewSubProducts) ||
                product.MainNewSubProducts.length === 0
            ) {
                return null;
            }
            let subProducts = [];
            if (!this.tShirt24Hour) {
                subProducts = product.MainNewSubProducts.filter(
                    (subProduct) => subProduct.default_selection == 1
                );
            } else {
                subProducts = product.MainNewSubProducts.filter(
                    (subProduct) =>
                        subProduct.Color && subProduct.Color.name == "White"
                );
            }
            return subProducts.length > 0
                ? subProducts[subProducts.length - 1]
                : product.MainNewSubProducts[0];
        },
        getTierRows(product, matrix, service = null) {
            if (!matrix) return [];
            if (Array.isArray(matrix)) return matrix;

            const decorationType = parseInt(
                (service && service.decoration_type) || product.decoration_type,
                10
            );
            if (
                decorationType === 0 ||
                decorationType === 1 ||
                decorationType === 5 
            ) {
                return matrix.print_location1 || matrix.print_location_1 || [];
            }
            if (decorationType === 2 || decorationType === 4) {
                return (
                    matrix.EmbroideryQuantities ||
                    matrix.embroidery_quantities ||
                    matrix.PatchQuantities ||
                    matrix.patch_quantities ||
                    []
                );
            }
            if (decorationType === 3) {
                return matrix.PromoQuantities || matrix.promo_quantities || [];
            }
            return [];
        },
        getHighestTier(rows) {
            if (!Array.isArray(rows) || rows.length === 0) return null;
            const sorted = [...rows].sort((a, b) => {
                const qa = parseFloat(a.quantity || a.quantity1 || 0);
                const qb = parseFloat(b.quantity || b.quantity1 || 0);
                return qa - qb;
            });
            return sorted[sorted.length - 1] || null;
        },
        discountedPrice(product) {
            let promotion_values = product.MainNewProductDiscount;
            let final_price = 0;
            if (!promotion_values) {
                return final_price;
            }
            let retail_price = Number(this.getRetailPrice(product));
            let discount_value = Number(promotion_values.discount_value);
            if (promotion_values.discount_type == "Percent") {
                final_price = retail_price * ((100 - discount_value) / 100);
            } else {
                final_price = retail_price - discount_value;
            }

            return final_price.toFixed(2);
        },
        getPromotionCost(product) {
            let promotion_values = product.MainNewProductDiscount;
            if (!promotion_values) {
                return;
            }
            var today = new Date();
            var enddate = new Date(promotion_values.end_date);
            var startdate = new Date(promotion_values.start_date);

            let returnvalue = "";

            if (enddate >= today && startdate <= today) {
                if (promotion_values.discount_value) {
                    returnvalue = Number(
                        promotion_values.discount_value
                    ).toFixed(2);
                }

                if (promotion_values.discount_type == "Flat") {
                    returnvalue = "-$" + returnvalue;
                } else {
                    returnvalue = "-" + returnvalue + "%";
                }
            }
            return returnvalue;
        },
        getRetailPrice(product) {
            let retail_price = 0;
            const service = this.getDefaultDecorationService(product);
            const matrix = this.parseMatrix(product, service);
            const tierRows = this.getTierRows(product, matrix, service);
            const highestTier = this.getHighestTier(tierRows);

            if (highestTier) {
                const useTemplate =
                    service &&
                    String(service.use_imprintcity_price_template) === "0"
                        ? 0
                        : 1;

                // PDP parity: when service provides retail tiers directly,
                // use retail_cost from the highest tier.
                const directRetail = parseFloat(
                    highestTier.retail_cost ||
                        highestTier.retail_price ||
                        highestTier.final_retail_cost ||
                        0
                );
                // In template mode we must compute live markup from base price + tier markup.
                // Using precomputed retail_cost here can bypass real-time markup updates.
                if (!isNaN(directRetail) && directRetail > 0 && useTemplate !== 1) {
                    retail_price = directRetail;
                } else {
                    const defaultSub = this.getDefaultSubProduct(product);
                    const basePrice =
                        parseFloat(product.price_base || 0) > 0
                            ? parseFloat(product.price_base || 0)
                            : parseFloat((defaultSub && defaultSub.price_base) || 0);
                    let markupValue = parseFloat(product.price_markup_value || 0);
                    const decorationCost = parseFloat(
                        highestTier.cost || highestTier.colour1 || highestTier.price || 0
                    );
                    const discount = parseFloat(highestTier.discount || 0);
                    // PDP computes markup from percentage in template mode.
                    if (useTemplate === 1 && service) {
                        const markupPercentage = this.getResolvedMarkupPercentage(
                            product,
                            service,
                            basePrice
                        );
                        markupValue = (basePrice * markupPercentage) / 100;
                    }

                    // PDP parity: use active service dark/light fee by default color.
                    let colorCategoryPrice = 0;
                    if (useTemplate === 1 && defaultSub && defaultSub.Color) {
                        const colorCategory = String(
                            defaultSub.Color.category || ""
                        )
                            .trim()
                            .toLowerCase();
                        if (colorCategory === "dark") {
                            colorCategoryPrice = parseFloat(
                                (service && service.price_dark) ||
                                    product.price_color_category_dark ||
                                    0
                            );
                        } else if (colorCategory === "light") {
                            colorCategoryPrice = parseFloat(
                                (service && service.price_light) ||
                                    product.price_color_category_light ||
                                    0
                            );
                        }
                    }

                    const subtotalBeforeDiscount =
                        basePrice +
                        markupValue +
                        decorationCost +
                        colorCategoryPrice;
                    retail_price =
                        discount > 0
                            ? subtotalBeforeDiscount * (1 - discount / 100)
                            : subtotalBeforeDiscount;
                }
            }

            if (isNaN(retail_price)) {
                retail_price = 0.0;
            }
            return this.icPriceFormat(retail_price, true);
        }
    }
};
</script>
